import { render, staticRenderFns } from "./VisualizarDadosContaAReceberAvulsaModal.vue?vue&type=template&id=76672ddb&scoped=true"
import script from "./VisualizarDadosContaAReceberAvulsaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VisualizarDadosContaAReceberAvulsaModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VisualizarDadosContaAReceberAvulsaModal.vue?vue&type=style&index=0&id=76672ddb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76672ddb",
  null
  
)

export default component.exports